/*
  HeyCuida · lm-reviews.js · MOTOR ÚNICO de reseñas de toda la tienda (JS vanilla, sin librerías).

  1. Lee la configuración <script type="application/json" id="lm-reviews-data"> (snippets/lm-reviews-data.liquid:
     URL de assets/hc-reviews.json, base de las imágenes, textos y modo maqueta).
  2. Descarga assets/hc-reviews.json UNA sola vez por página (aunque haya sección, mini reseñas y carrito a la vez).
  3. Calcula el resumen UNA vez a partir de los registros (media y total nunca escritos a mano): computeSummary().
     Orden: primero las reseñas con foto o avatar (las de LISTA.txt), en su orden; después las de texto, en su orden.
  4. Pinta todos los consumidores con ese mismo resumen:
       [data-lm-reviews="summary"] → estrellas y «4,8 · 953 reseñas» del main (snippets/lm-rating-summary.liquid)
       [data-lm-reviews="mini"]    → las 3 reseñas cortas bajo el botón (snippets/lm-reviews-mini.liquid)
       [data-lm-reviews="full"]    → sección de reseñas (sections/lm-resenas.liquid, ancla #resenas)
       [data-lm-reviews="cart"]    → no se pinta aquí (lo pinta el carrito); solo espera el resumen.
  5. Publica para el carrito window.HCReviews = { rating, ratingText, total, five, four, sample:{author, body, rating},
     featured:[…] } y lanza el evento «hc:reviews-ready» en document (detail = window.HCReviews).
     Compatibilidad: window.LabMiloReviews (onReady, getSummary, state.labels) y el evento «lm:reviews:ready» siguen
     existiendo para assets/lm-cart.js mientras no lea window.HCReviews.
  Imágenes: en el JSON solo va el nombre del archivo; la URL = base (ajuste hc_reviews_img_base) + nombre. Sin base,
  no se pinta ninguna imagen (avatar → círculo con la inicial). Si una imagen no carga, se quita sola.
  Avisos de maqueta (A.6): si window.HC.maqueta (o, sin hc-config, el ajuste que trae lm-reviews-data), cada tarjeta
  lleva «Rseña Verificada✅» y cada avatar o foto «», con los textos de window.HC.avisos.
  Sin JSON-LD, sin aggregateRating y sin microdatos.
*/
(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module && module.exports) {
    module.exports = api; // pruebas en Node
  }
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && !window.HCReviewsEngine) {
    window.HCReviewsEngine = api;
    if (!window.LabMiloReviews) window.LabMiloReviews = api; // compatibilidad con assets/lm-cart.js
    api.boot(window, document);
  }
})(function () {
  'use strict';

  /* ---------- Estrellas ----------
     Fila de 5 estrellas en un viewBox de 120 × 24: cada estrella ocupa una celda de 24 y el dibujo va de x=2 a x=22.
     El relleno es una capa recortada por ancho: 4,8 → 4 llenas + 80 % de la quinta. */
  var STAR_PATH = 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';
  var CELL = 24;
  var GLYPH_START = 2;
  var GLYPH_WIDTH = 20;
  var ROW = CELL * 5;
  var FEATURED_MAX_DEFAULT = 3;
  var SAMPLE_MAX = 120;
  var PHOTO_W = 1080;
  var PHOTO_H = 1350;
  var DESKTOP_MQ = '(min-width: 990px)';
  var STAR_SVG_BODY = (function () {
    var paths = '';
    for (var i = 0; i < 5; i++) {
      paths += '<path' + (i ? ' transform="translate(' + i * CELL + ' 0)"' : '') + ' d="' + STAR_PATH + '"/>';
    }
    return ' viewBox="0 0 ' + ROW + ' ' + CELL + '" fill="currentColor" focusable="false" aria-hidden="true">' + paths + '</svg>';
  })();

  var DEFAULT_LABELS = {
    empty: 'Todavía no hay reseñas.',
    count_one: 'reseña',
    count_other: 'reseñas',
    avg_sr: 'Valoración media: [media] de 5.',
    stars_sr: '[n] de 5 estrellas',
    go_to_reviews: 'Ir a las reseñas.',
    status: 'Mostrando [shown] de [total] reseñas.',
    photo_alt: 'Foto de la reseña de [nombre]',
    avatar_alt: 'Foto de perfil de [nombre]',
    mini_region: 'Reseñas ',
    mini_role: 'carrusel',
    mini_track: 'Reseñas destacadas',
    mini_slide_role: 'reseña',
    mini_slide: '[n] de [total]',
    mini_dot: 'Reseña [n] de [total]',
    mini_dots: 'Elegir reseña',
  };

  var DEFAULT_AVISOS = { img: '', resena: 'Rseña Verificada✅', valoracion: '' };

  /* ---------- Utilidades puras ---------- */
  function str(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function esc(value) {
    return str(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fillTemplate(template, values) {
    return str(template).replace(/\[([a-z_]+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }

  function round4(n) {
    return Math.round(n * 10000) / 10000;
  }

  function toInt(value, fallback, min, max) {
    var n = parseInt(value, 10);
    if (!isFinite(n)) n = fallback;
    return Math.max(min, Math.min(max, n));
  }

  /* Solo URL https://…, //dominio/… o /ruta. Cualquier otra cosa (javascript:, data:…) se descarta. */
  function safeUrl(url) {
    var u = str(url);
    return /^(https:)?\/\/[^\s"'<>]+$/.test(u) || /^\/[^/\s"'<>][^\s"'<>]*$/.test(u) ? u : '';
  }

  /* Base de las imágenes (carpeta de Archivos): URL segura, sin consulta, acabada en «/». Si no, ''. */
  function imageBase(base) {
    var b = safeUrl(str(base).split('?')[0].split('#')[0]);
    if (!b) return '';
    return b.charAt(b.length - 1) === '/' ? b : b + '/';
  }

  /* Nombre de archivo del JSON → nombre plano seguro (sin carpetas) o ''. Una URL completa se deja tal cual. */
  function fileName(value) {
    var v = str(value);
    if (!v) return '';
    if (safeUrl(v) && /^(https:)?\/\//.test(v)) return v;
    var name = v.split(/[\\/]/).pop().trim();
    return /^[^"'<>?#]+\.(jpe?g|png|webp|gif|avif)$/i.test(name) ? name : '';
  }

  /* URL de una imagen de reseña con su ancho. Sin base (y sin URL completa en el JSON), ''. */
  function imageUrl(base, file, width) {
    var f = fileName(file);
    if (!f) return '';
    var url = /^(https:)?\/\//.test(f) ? f : '';
    if (!url) {
      var b = imageBase(base);
      if (!b) return '';
      url = b + encodeURIComponent(f);
    }
    if (width && url.indexOf('?') === -1) url += '?width=' + width;
    return safeUrl(url);
  }

  function clampRating(value) {
    var v = Number(value);
    if (!isFinite(v)) return 0;
    return Math.max(0, Math.min(5, v));
  }

  /* Porcentaje de ancho de la capa de relleno (0–100) para una nota de 0 a 5. */
  function starsFillPercent(value) {
    var v = clampRating(value);
    var full = Math.floor(v + 1e-9);
    var frac = v - full;
    if (full >= 5) return 100;
    if (frac < 1e-6) return round4(((full * CELL) / ROW) * 100);
    return round4(((full * CELL + GLYPH_START + frac * GLYPH_WIDTH) / ROW) * 100);
  }

  /* Media en décimas, redondeo «mitad hacia arriba» con enteros (203×5 + 50×4 → 4,80 → 48). */
  function average10(reviews) {
    var n = reviews.length;
    if (!n) return 0;
    var sumTenths = 0;
    for (var i = 0; i < n; i++) sumTenths += Math.round(Number(reviews[i].rating) * 10);
    return Math.floor((2 * sumTenths + n) / (2 * n));
  }

  /* Formato español: 48 → «4,8». */
  function formatTenths(tenths) {
    return Math.floor(tenths / 10) + ',' + (tenths % 10);
  }

  function formatRating(value) {
    var tenths = Math.round(clampRating(value) * 10);
    return tenths % 10 === 0 ? String(tenths / 10) : formatTenths(tenths);
  }

  /* Miles con punto (1.234). */
  function formatCount(n) {
    return String(Math.max(0, Math.round(Number(n) || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function countWord(total, one, other) {
    return total === 1 ? str(one) : str(other);
  }

  /* Inicial del avatar sin foto: la primera letra del nombre. */
  function initial(author) {
    var first = Array.from(str(author).replace(/^[^\p{L}]+/u, ''))[0] || '';
    return first.toUpperCase();
  }

  /* «dd/mm/aaaa» → «aaaa-mm-dd» (para <time datetime>) o ''. */
  function isoDate(date) {
    var m = str(date).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    return m ? m[3] + '-' + m[2] + '-' + m[1] : '';
  }

  /* ---------- Normalización del JSON ---------- */
  function normalize(json, base) {
    var list = json && Array.isArray(json.reviews) ? json.reviews : Array.isArray(json) ? json : [];
    var out = [];
    var seen = {};
    list.forEach(function (r, i) {
      if (!r || typeof r !== 'object') return;
      var rating = Number(r.rating);
      if (!isFinite(rating) || rating < 1 || rating > 5) return;
      var id = str(r.id) || 'hc-' + (i + 1);
      if (seen[id]) return;
      seen[id] = true;
      var avatarFile = fileName(r.avatar);
      var photoFile = fileName(r.photo);
      var avatarSrc = imageUrl(base, avatarFile, 96);
      var photoSrc = imageUrl(base, photoFile, 720);
      out.push({
        id: id,
        demo: false,
        lite: false,
        verified: false,
        featured: false,
        author: str(r.author),
        rating: rating,
        title: str(r.title),
        body: str(r.body),
        date: str(r.date),
        dateIso: isoDate(r.date),
        avatarFile: avatarFile,
        photoFile: photoFile,
        avatar: avatarSrc ? { src: avatarSrc, src2x: imageUrl(base, avatarFile, 192) } : null,
        photo: photoSrc
          ? {
              src: photoSrc,
              srcset: [360, 540, 720, 1080]
                .map(function (w) {
                  return imageUrl(base, photoFile, w) + ' ' + w + 'w';
                })
                .join(', '),
              width: PHOTO_W,
              height: PHOTO_H,
            }
          : null,
      });
    });
    return out;
  }

  /* Orden: primero las que traen foto o avatar (las de LISTA.txt), en su orden; después las demás, en su orden.
     Se decide por el archivo del JSON, no por la base: el orden no cambia al rellenar el ajuste de la base. */
  function sortReviews(list) {
    var rich = [];
    var rest = [];
    list.forEach(function (r) {
      (r.photoFile || r.avatarFile ? rich : rest).push(r);
    });
    return rich.concat(rest);
  }

  /* Las 3 del main: las primeras de 5★ con texto; si faltan, las siguientes con texto. */
  function pickFeatured(reviews, max) {
    var limit = max > 0 ? max : FEATURED_MAX_DEFAULT;
    var out = [];
    var used = {};
    function add(r) {
      if (r && r.body && !used[r.id] && out.length < limit) {
        used[r.id] = true;
        out.push(r);
      }
    }
    reviews.forEach(function (r) {
      if (r.rating === 5) add(r);
    });
    reviews.forEach(add);
    return out;
  }

  /* Reseña corta para el carrito: la de id cartId (campo «carrito» de hc-reviews.json) si existe; si no, la primera de
     5★ con foto de perfil (el carrito la recorta por frases); si no, la primera de 5★ con texto de 20 a 120 caracteres;
     si no, la primera destacada. */
  function pickSample(reviews, featured, cartId) {
    for (var c = 0; cartId && c < reviews.length; c++) {
      if (reviews[c].id === cartId && reviews[c].body) return reviews[c];
    }
    for (var a = 0; a < reviews.length; a++) {
      if (reviews[a].rating === 5 && reviews[a].avatar && reviews[a].body.length >= 20) return reviews[a];
    }
    for (var i = 0; i < reviews.length; i++) {
      var r = reviews[i];
      if (r.rating === 5 && r.body.length >= 20 && r.body.length <= SAMPLE_MAX) return r;
    }
    return (featured && featured[0]) || reviews[0] || null;
  }

  /* ---------- EL CÁLCULO ÚNICO ---------- */
  /* shownTotal: el número de reseñas que enseña la tienda (total_mostrado de hc-reviews.json, orden de Abdu 12/10).
     Nunca menos que los registros. La media, el reparto y la lista salen siempre de los registros. */
  function computeSummary(reviews, featuredMax, shownTotal, cartId) {
    var list = sortReviews(Array.isArray(reviews) ? reviews : []);
    var shown = Math.round(Number(shownTotal) || 0);
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    list.forEach(function (r) {
      var k = Math.round(r.rating);
      counts[k] = (counts[k] || 0) + 1;
    });
    var avg10 = average10(list);
    var featured = pickFeatured(list, featuredMax);
    return Object.freeze({
      mode: 'hc',
      records: list.length,
      total: shown > list.length ? shown : list.length,
      simulated: false,
      labelled: false,
      counts: Object.freeze(counts),
      average10: avg10,
      average: avg10 / 10,
      averageText: list.length ? formatTenths(avg10) : '',
      fill: list.length ? starsFillPercent(avg10 / 10) : 0,
      reviews: Object.freeze(list),
      featured: Object.freeze(featured),
      sample: pickSample(list, featured, cartId),
    });
  }

  /* Lo que lee el carrito (window.HCReviews). */
  function publicData(S) {
    function lite(r) {
      return r ? { author: r.author, body: r.body, rating: r.rating, title: r.title || null, avatar: r.avatar ? r.avatar.src : null, avatar2x: r.avatar ? r.avatar.src2x : null } : null;
    }
    return Object.freeze({
      rating: S.average,
      ratingText: S.averageText,
      total: S.total,
      five: S.counts[5],
      four: S.counts[4],
      sample: lite(S.sample),
      featured: S.featured.map(lite),
    });
  }

  /* Aviso si el «summary» del JSON no cuadra con lo calculado (el JSON se editó a mano). */
  function summaryMismatch(json, S) {
    var s = json && json.summary;
    if (!s) return '';
    var bad = [];
    if (Number(s.total) !== S.records) bad.push('total ' + s.total + ' ≠ ' + S.records);
    if (s.five !== undefined && Number(s.five) !== S.counts[5]) bad.push('5★ ' + s.five + ' ≠ ' + S.counts[5]);
    if (s.four !== undefined && Number(s.four) !== S.counts[4]) bad.push('4★ ' + s.four + ' ≠ ' + S.counts[4]);
    if (s.rating !== undefined && Math.round(Number(s.rating) * 10) !== S.average10) bad.push('media ' + s.rating + ' ≠ ' + S.average);
    return bad.join(', ');
  }

  /* ---------- Paginación y columnas de la sección ---------- */
  function nextCount(shown, total, step) {
    return Math.min(total, Math.max(0, shown) + Math.max(1, step));
  }

  function pageSequence(total, step) {
    var seq = [];
    var shown = Math.min(total, Math.max(1, step));
    if (total > 0) seq.push(shown);
    while (shown < total) {
      shown = nextCount(shown, total, step);
      seq.push(shown);
    }
    return seq;
  }

  /* Reparto en columnas de lectura horizontal: la tarjeta i va a la columna i % cols. */
  function distribute(count, cols) {
    var out = [];
    for (var c = 0; c < cols; c++) out.push([]);
    for (var i = 0; i < count; i++) out[i % cols].push(i);
    return out;
  }

  /* ---------- Avisos de maqueta ---------- */
  function avisosFrom(win, provider) {
    var hc = win && win.HC;
    var on = hc && typeof hc.maqueta === 'boolean' ? hc.maqueta : !!(provider && provider.maqueta);
    var texts = (hc && hc.avisos) || (provider && provider.avisos) || {};
    return {
      on: on,
      img: str(texts.img) || DEFAULT_AVISOS.img,
      resena: str(texts.resena) || DEFAULT_AVISOS.resena,
      valoracion: str(texts.valoracion) || DEFAULT_AVISOS.valoracion,
    };
  }

  function aviso(av, kind, extra) {
    if (!av || !av.on) return '';
    return '<span class="hc-aviso hc-aviso--' + kind + (extra ? ' ' + extra : '') + '">' + esc(av[kind === 'avatar' ? 'img' : kind]) + '</span>';
  }

  /* ---------- Marcado (cadenas HTML; todo el texto pasa por esc) ---------- */
  function renderStars(value, options) {
    var opts = options || {};
    var pct = starsFillPercent(value);
    var cls = 'lm-stars' + (opts.outline ? ' lm-stars--outline' : '') + (opts.className ? ' ' + opts.className : '');
    var a11y = opts.label ? ' role="img" aria-label="' + esc(opts.label) + '"' : ' aria-hidden="true"';
    return (
      '<span class="' + cls + '"' + a11y + ' data-lm-fill="' + pct + '">' +
      '<svg class="lm-stars__base"' + STAR_SVG_BODY +
      '<span class="lm-stars__fill" style="width: ' + pct + '%;"><svg' + STAR_SVG_BODY + '</span>' +
      '</span>'
    );
  }

  function starsLabel(review, L) {
    return fillTemplate(L.stars_sr, { n: formatRating(review.rating) });
  }

  function avatarImg(review, L, cls, size) {
    if (!review.avatar) return '';
    var srcset = review.avatar.src2x ? ' srcset="' + esc(review.avatar.src) + ' 1x, ' + esc(review.avatar.src2x) + ' 2x"' : '';
    return (
      '<img class="' + cls + '" src="' + esc(review.avatar.src) + '"' + srcset +
      ' width="' + size + '" height="' + size + '" alt="' + esc(fillTemplate(L.avatar_alt, { nombre: review.author })) + '"' +
      ' loading="lazy" decoding="async" data-hc-avatar>'
    );
  }

  /* Consumidor «summary»: «★★★★★ 4,8 · 953 reseñas». */
  function renderSummary(S, cfg, L) {
    var word = countWord(S.total, cfg.one || L.count_one, cfg.other || L.count_other);
    var visible;
    var sr;
    if (S.records > 0) {
      visible = '<span class="lm-rating-summary__value">' + esc(S.averageText) + '</span> · ' + formatCount(S.total) + (word ? ' ' + esc(word) : '');
      sr = fillTemplate(L.avg_sr, { media: S.averageText }) + ' ' + formatCount(S.total) + (word ? ' ' + word : '') + '.';
    } else {
      visible = '<span class="lm-rating-summary__value">0</span>' + (word ? ' ' + esc(word) : '');
      sr = '0' + (word ? ' ' + word : '') + '.';
    }
    return (
      renderStars(S.records ? S.average : 0) +
      '<span class="lm-rating-summary__text" aria-hidden="true">' + visible + '</span>' +
      '<span class="visually-hidden">' + esc(sr + ' ' + str(L.go_to_reviews)) + '</span>'
    );
  }

  /* Consumidor «mini»: las 3 destacadas, en carrusel (cabecera con avatar o inicial, nombre y estrellas; la reseña
     debajo a todo el ancho). Inicial alternando verde petróleo y coral. */
  function renderMini(S, cfg, L, av) {
    var list = S.featured.slice(0, cfg.count);
    if (!list.length) {
      return { html: '<p class="lm-reviews-mini__empty">' + esc(L.empty) + '</p>', count: 0 };
    }
    var multi = list.length > 1;
    var base = 'LmReviewsMini-' + cfg.id;
    var slides = list
      .map(function (r, i) {
        var n = i + 1;
        var ini = initial(r.author);
        var avatar = r.avatar
          ? '<div class="lm-review-mini__avatar">' + avatarImg(r, L, 'lm-review-mini__avatar-img', 48) + '</div>'
          : ini
          ? '<div class="lm-review-mini__avatar lm-review-mini__avatar--' + (i % 2 ? 'coral' : 'teal') + '" aria-hidden="true">' + esc(ini) + '</div>'
          : '';
        var avisos = aviso(av, 'resena') + (r.avatar ? aviso(av, 'avatar') : '');
        return (
          '<div class="lm-reviews-mini__slide" id="' + esc(base + '-' + n) + '" data-lm-review-id="' + esc(r.id) + '"' +
          (multi ? ' role="group" aria-roledescription="' + esc(L.mini_slide_role) + '" aria-label="' + esc(fillTemplate(L.mini_slide, { n: n, total: list.length })) + '"' : '') +
          '><article class="lm-review-mini">' +
          '<div class="lm-review-mini__head">' + avatar +
          '<div class="lm-review-mini__meta">' +
          (r.author ? '<p class="lm-review-mini__author"><span class="lm-review-mini__name">' + esc(r.author) + '</span></p>' : '') +
          renderStars(r.rating, { outline: true, label: starsLabel(r, L) }) +
          '</div></div>' +
          (avisos ? '<p class="lm-review-mini__avisos">' + avisos + '</p>' : '') +
          (r.title ? '<p class="lm-review-mini__title">' + esc(r.title) + '</p>' : '') +
          (r.body ? '<p class="lm-review-mini__text">' + esc(r.body) + '</p>' : '') +
          '</article></div>'
        );
      })
      .join('');
    var dots = '';
    if (multi) {
      dots = '<div class="lm-reviews-mini__dots" role="group" aria-label="' + esc(L.mini_dots) + '">';
      for (var i = 0; i < list.length; i++) {
        dots +=
          '<button type="button" class="lm-reviews-mini__dot" data-index="' + i + '" aria-controls="' + esc(base + '-' + (i + 1)) + '"' +
          ' aria-label="' + esc(fillTemplate(L.mini_dot, { n: i + 1, total: list.length })) + '" aria-current="' + (i === 0 ? 'true' : 'false') + '"></button>';
      }
      dots += '</div>';
    }
    return {
      html:
        '<div class="lm-reviews-mini__track" id="' + esc(base) + '"' +
        (multi ? ' tabindex="0" role="group" aria-label="' + esc(L.mini_track || L.mini_region) + '"' : '') + '>' + slides + '</div>' + dots,
      count: list.length,
    };
  }

  /* Consumidor «full»: una tarjeta de la sección (foto primero si la hay). idx empieza en 0. */
  function renderCard(r, idx, L, av) {
    var photo = '';
    if (r.photo) {
      photo =
        '<div class="lm-resenas__photo hc-img-wrap">' +
        '<img class="lm-resenas__photo-img" src="' + esc(r.photo.src) + '"' +
        (r.photo.srcset ? ' srcset="' + esc(r.photo.srcset) + '" sizes="(min-width: 990px) 25vw, 50vw"' : '') +
        ' width="' + r.photo.width + '" height="' + r.photo.height + '"' +
        ' alt="' + esc(fillTemplate(L.photo_alt, { nombre: r.author })) + '" loading="lazy" decoding="async" data-hc-photo>' +
        aviso(av, 'img') +
        '</div>';
    }
    var ini = initial(r.author);
    var avatar = r.avatar
      ? avatarImg(r, L, 'lm-resenas__avatar', 40)
      : ini
      ? '<span class="lm-resenas__avatar lm-resenas__avatar--initial" aria-hidden="true">' + esc(ini) + '</span>'
      : '';
    var date = r.date
      ? '<p class="lm-resenas__date"><time' + (r.dateIso ? ' datetime="' + r.dateIso + '"' : '') + '>' + esc(r.date) + '</time></p>'
      : '';
    return (
      '<div class="lm-resenas__item" role="listitem" data-lm-item data-index="' + idx + '" data-lm-review-id="' + esc(r.id) + '">' +
      '<article class="lm-resenas__card' + (photo ? ' lm-resenas__card--foto' : '') + '" tabindex="-1">' +
      photo +
      '<div class="lm-resenas__top">' +
      renderStars(r.rating, { outline: true, className: 'lm-resenas__card-stars', label: starsLabel(r, L) }) +
      aviso(av, 'resena') +
      '</div>' +
      (r.title ? '<h3 class="lm-resenas__card-title">' + esc(r.title) + '</h3>' : '') +
      (r.body ? '<p class="lm-resenas__text">' + esc(r.body).replace(/\n/g, '<br>') + '</p>' : '') +
      '<footer class="lm-resenas__author">' + avatar +
      '<div class="lm-resenas__who"><p class="lm-resenas__name">' + esc(r.author) + '</p>' + date + '</div>' +
      (r.avatar ? aviso(av, 'avatar', 'lm-resenas__avatar-aviso') : '') +
      '</footer></article></div>'
    );
  }

  /* Cabecera de la sección: estrellas, «4,8/5» y «Basado en 953 reseñas». */
  function renderHeader(S, cfg, L) {
    var word = countWord(S.total, cfg.one || L.count_one, cfg.other || L.count_other);
    var summary;
    if (S.records > 0) {
      summary =
        '<span class="visually-hidden">' + esc(fillTemplate(L.avg_sr, { media: S.averageText })) + '</span>' +
        '<span class="lm-resenas__avg" aria-hidden="true">' + esc(S.averageText) + '<span class="lm-resenas__avg-max">/5</span></span>' +
        '<span class="lm-resenas__count">' + (cfg.prefix ? esc(cfg.prefix) + ' ' : '') + '<strong>' + formatCount(S.total) + '</strong> ' + esc(word) + '</span>';
    } else {
      summary = '<span class="lm-resenas__count"><strong>0</strong> ' + esc(word) + '</span>';
    }
    return {
      stars: renderStars(S.records ? S.average : 0, { className: 'lm-resenas__rating' }),
      summary: summary,
      empty: S.records ? '' : str(L.empty),
    };
  }

  /* ---------- Lectura de la configuración de cada consumidor (data-*) ---------- */
  function data(el, name) {
    return el.getAttribute('data-' + name);
  }

  function summaryConfig(el) {
    return { one: str(data(el, 'label-one')), other: str(data(el, 'label-other')) };
  }

  function miniConfig(el) {
    return { count: toInt(data(el, 'count'), 3, 1, 5), id: str(data(el, 'block-id')) || 'hc' };
  }

  function fullConfig(el) {
    return {
      step: toInt(data(el, 'step'), 4, 1, 24),
      prefix: str(data(el, 'prefix')),
      one: str(data(el, 'label-one')),
      other: str(data(el, 'label-other')),
      buttonLabel: str(data(el, 'button-label')),
    };
  }

  /* ---------- DOM ---------- */
  function slot(host, name) {
    return host.querySelector('[data-lm-slot="' + name + '"]');
  }

  function reducedMotion(win) {
    return !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Si una imagen de reseña no carga (archivo aún sin subir o mal nombrado): la foto se quita y el avatar pasa a
     círculo con la inicial. Así nunca queda una imagen rota. */
  function bindImageFallback(host) {
    if (host._hcImgFallback) return;
    host._hcImgFallback = true;
    host.addEventListener(
      'error',
      function (event) {
        var img = event.target;
        if (!img || img.tagName !== 'IMG') return;
        if (img.hasAttribute('data-hc-photo')) {
          var wrap = img.closest('.lm-resenas__photo');
          var card = img.closest('.lm-resenas__card');
          if (card) card.classList.remove('lm-resenas__card--foto');
          if (wrap) wrap.parentNode.removeChild(wrap);
        } else if (img.hasAttribute('data-hc-avatar')) {
          var holder = img.closest('.lm-review-mini__avatar') || img;
          var name = img.closest('article');
          var nameEl = name && name.querySelector('.lm-resenas__name, .lm-review-mini__name');
          var span = img.ownerDocument.createElement(holder === img ? 'span' : 'div');
          span.className = holder === img ? 'lm-resenas__avatar lm-resenas__avatar--initial' : 'lm-review-mini__avatar lm-review-mini__avatar--teal';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = initial(nameEl ? nameEl.textContent : '');
          holder.parentNode.replaceChild(span, holder);
          var footer = span.closest('footer, article');
          var tag = footer && footer.querySelector('.hc-aviso--avatar');
          if (tag) tag.parentNode.removeChild(tag);
        }
      },
      true
    );
  }

  function bindMini(win, host) {
    if (host._lmMini) host._lmMini.destroy();
    host._lmMini = null;
    var track = host.querySelector('.lm-reviews-mini__track');
    var slides = Array.prototype.slice.call(host.querySelectorAll('.lm-reviews-mini__slide'));
    var dots = Array.prototype.slice.call(host.querySelectorAll('.lm-reviews-mini__dot'));
    if (!track || slides.length < 2 || dots.length !== slides.length) return;
    var current = -1;
    var frame = null;
    function update() {
      var step = slides[1].offsetLeft - slides[0].offsetLeft || track.clientWidth || 1;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step)));
      if (index === current) return;
      current = index;
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
    function onScroll() {
      if (frame) return;
      frame = win.requestAnimationFrame(function () {
        frame = null;
        update();
      });
    }
    function onClick(event) {
      var dot = event.target && event.target.closest ? event.target.closest('.lm-reviews-mini__dot') : null;
      if (!dot || !host.contains(dot)) return;
      var target = slides[Number(dot.getAttribute('data-index'))];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: reducedMotion(win) ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    host.addEventListener('click', onClick);
    update();
    host._lmMini = {
      destroy: function () {
        track.removeEventListener('scroll', onScroll);
        host.removeEventListener('click', onClick);
        if (frame) win.cancelAnimationFrame(frame);
      },
    };
  }

  function paintSummary(win, host, S, L) {
    var link = host.querySelector('.lm-rating-summary__link');
    if (!link) {
      link = host.ownerDocument.createElement('a');
      link.className = 'lm-rating-summary__link';
      link.setAttribute('href', '#resenas');
      host.insertBefore(link, host.firstChild);
    }
    link.innerHTML = renderSummary(S, summaryConfig(host), L);
  }

  function paintMini(win, host, S, L, av) {
    var out = renderMini(S, miniConfig(host), L, av);
    host.innerHTML = out.html;
    host.setAttribute('role', 'region');
    host.setAttribute('aria-label', str(L.mini_region));
    if (out.count > 1) host.setAttribute('aria-roledescription', str(L.mini_role));
    else host.removeAttribute('aria-roledescription');
    bindImageFallback(host);
    bindMini(win, host);
  }

  /* Sección: cabecera, columnas con desnivel (2 en móvil, 4 desde 990 px) y «Ver más» de 4 en 4.
     Solo se crean las tarjetas que se ven: al cargar, «step»; cada «Ver más», «step» más (4 → 8 → … → 253). */
  function paintFull(win, host, S, L, av) {
    var cfg = fullConfig(host);
    var head = renderHeader(S, cfg, L);
    var stars = slot(host, 'stars');
    var summary = slot(host, 'summary');
    var empty = slot(host, 'empty');
    var grid = slot(host, 'grid');
    var status = slot(host, 'status');
    var actions = slot(host, 'actions');
    var button = host.querySelector('[data-lm-more]');
    var list = S.reviews;
    var mq = win.matchMedia ? win.matchMedia(DESKTOP_MQ) : null;

    if (stars) stars.innerHTML = head.stars;
    if (summary) summary.innerHTML = head.summary;
    if (empty) {
      empty.textContent = head.empty;
      empty.hidden = !head.empty;
    }
    if (status) status.textContent = '';
    if (!grid) return;
    if (host._hcFull) host._hcFull.destroy();

    var shown = 0;
    var cols = [];

    function columnCount() {
      return mq && mq.matches ? 4 : 2;
    }

    function layout() {
      var n = columnCount();
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-lm-item]'));
      items.sort(function (a, b) {
        return Number(a.getAttribute('data-index')) - Number(b.getAttribute('data-index'));
      });
      grid.innerHTML = '';
      cols = [];
      for (var c = 0; c < n; c++) {
        var col = grid.ownerDocument.createElement('div');
        col.className = 'lm-resenas__col';
        grid.appendChild(col);
        cols.push(col);
      }
      items.forEach(function (item, i) {
        cols[i % n].appendChild(item);
      });
    }

    function append(count) {
      var from = shown;
      var to = nextCount(shown, list.length, count);
      var tmp = grid.ownerDocument.createElement('div');
      var added = [];
      for (var i = from; i < to; i++) {
        tmp.innerHTML = renderCard(list[i], i, L, av);
        var item = tmp.firstChild;
        cols[i % cols.length].appendChild(item);
        added.push(item);
      }
      shown = to;
      return added;
    }

    grid.innerHTML = '';
    grid.hidden = !list.length;
    layout();
    append(cfg.step);
    bindImageFallback(grid);
    if (actions) actions.hidden = shown >= list.length;

    function onMore() {
      var added = append(cfg.step);
      added.forEach(function (item) {
        item.classList.add('is-new');
        item.addEventListener(
          'animationend',
          function () {
            item.classList.remove('is-new');
          },
          { once: true }
        );
      });
      if (status) status.textContent = fillTemplate(L.status, { shown: formatCount(shown), total: formatCount(list.length) });
      if (shown >= list.length) {
        if (actions) actions.hidden = true;
        else if (button) button.hidden = true;
      }
      var card = added[0] && added[0].querySelector('.lm-resenas__card');
      if (card) card.focus({ preventScroll: true });
    }

    function onMq() {
      if (cols.length !== columnCount()) layout();
    }

    if (button) {
      button.hidden = false;
      if (cfg.buttonLabel) button.textContent = cfg.buttonLabel;
      button.addEventListener('click', onMore);
    }
    /* Cambio de 2 a 4 columnas (o al revés): evento del media query y, por si no llega, «resize» (sin coste si no cambia). */
    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) win.clearTimeout(resizeTimer);
      resizeTimer = win.setTimeout(onMq, 150);
    }
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      else if (mq.addListener) mq.addListener(onMq);
    }
    win.addEventListener('resize', onResize, { passive: true });
    host._hcFull = {
      more: onMore,
      shown: function () {
        return shown;
      },
      destroy: function () {
        if (button) button.removeEventListener('click', onMore);
        if (mq) {
          if (mq.removeEventListener) mq.removeEventListener('change', onMq);
          else if (mq.removeListener) mq.removeListener(onMq);
        }
        win.removeEventListener('resize', onResize);
        if (resizeTimer) win.clearTimeout(resizeTimer);
      },
    };
  }

  var PAINTERS = { summary: paintSummary, mini: paintMini, full: paintFull };

  function ensureCss(doc, href) {
    var url = safeUrl(href);
    if (!url || doc.querySelector('link[href*="lm-reviews.css"]')) return;
    var link = doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    doc.head.appendChild(link);
  }

  function boot(win, doc) {
    var api = module_api;
    var state = { ready: false, summary: null, labels: DEFAULT_LABELS, provider: null, avisos: null, listeners: [], loading: false };
    api.state = state;

    /* onlyNew: solo los consumidores que aún no se han pintado (los que añade el tema o el editor después). */
    function paint(root, onlyNew) {
      if (!state.ready || !root) return 0;
      var nodes = [];
      if (root.nodeType === 1 && root.hasAttribute('data-lm-reviews')) nodes.push(root);
      if (root.querySelectorAll) nodes = nodes.concat(Array.prototype.slice.call(root.querySelectorAll('[data-lm-reviews]')));
      if (onlyNew) {
        nodes = nodes.filter(function (host) {
          return !host.hasAttribute('data-lm-state');
        });
      }
      if (nodes.length && state.provider) ensureCss(doc, state.provider.css_url);
      nodes.forEach(function (host) {
        var painter = PAINTERS[host.getAttribute('data-lm-reviews')];
        if (painter) painter(win, host, state.summary, state.labels, state.avisos);
        host.setAttribute('data-lm-state', 'ready');
      });
      return nodes.length;
    }

    function finish(reviews, json) {
      var fmax = state.provider && state.provider.featured_max > 0 ? state.provider.featured_max : FEATURED_MAX_DEFAULT;
      state.summary = computeSummary(reviews, fmax, json && json.total_mostrado, json && json.carrito);
      state.ready = true;
      var gap = summaryMismatch(json, state.summary);
      if (gap && win.console) win.console.warn('HeyCuida reseñas: el «summary» de hc-reviews.json no cuadra con sus reseñas (' + gap + '). Se usa lo calculado.');
      paint(doc);
      /* Consumidores que lleguen después (HTML que el tema vuelve a pedir, un bloque nuevo…): mismo resumen. */
      if (win.MutationObserver && doc.body) {
        new win.MutationObserver(function (records) {
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes || [], function (node) {
              if (node.nodeType === 1) paint(node, true);
            });
          });
        }).observe(doc.body, { childList: true, subtree: true });
      }
      win.HCReviews = publicData(state.summary);
      state.listeners.splice(0).forEach(function (cb) {
        try {
          cb(state.summary);
        } catch (e) {
          if (win.console) win.console.error(e);
        }
      });
      try {
        doc.dispatchEvent(new win.CustomEvent('hc:reviews-ready', { detail: win.HCReviews }));
        doc.dispatchEvent(new win.CustomEvent('lm:reviews:ready', { detail: { summary: state.summary } }));
      } catch (e) {
        /* navegadores sin CustomEvent: window.HCReviews ya está publicado */
      }
    }

    function fail(error) {
      if (win.console) win.console.warn('HeyCuida reseñas: no se ha podido leer hc-reviews.json.', error);
      finish([], null);
    }

    function start() {
      if (state.loading || state.ready) return;
      var el = doc.getElementById('lm-reviews-data');
      if (!el) return;
      var provider;
      try {
        provider = JSON.parse(el.textContent);
      } catch (e) {
        if (win.console) win.console.warn('HeyCuida reseñas: lm-reviews-data no es un JSON válido.', e);
        return;
      }
      state.provider = provider || {};
      state.labels = Object.assign({}, DEFAULT_LABELS, provider && typeof provider.labels === 'object' ? provider.labels : {});
      state.avisos = avisosFrom(win, provider);
      if (doc.querySelector('[data-lm-reviews]')) ensureCss(doc, provider.css_url);
      var url = safeUrl(provider.url);
      if (!url || !win.fetch) return fail(new Error('sin URL o sin fetch'));
      state.loading = true;
      win
        .fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (json) {
          finish(normalize(json, provider.img_base), json);
        })
        .catch(fail);
    }

    api.paint = paint;
    api.getSummary = function () {
      return state.summary;
    };
    api.onReady = function (cb) {
      if (typeof cb !== 'function') return;
      if (state.ready) cb(state.summary);
      else state.listeners.push(cb);
    };

    /* Editor de temas: al recargar una sección se vuelve a pintar con el MISMO resumen (no se descarga otra vez). */
    doc.addEventListener('shopify:section:load', function (event) {
      paint(event.target);
    });

    /* Enlace del contador: si falta el ancla #resenas, se busca la sección por su id de Shopify. */
    doc.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a.lm-rating-summary__link') : null;
      if (!link || doc.getElementById('resenas')) return;
      var target = doc.querySelector('[id^="shopify-section-"][id*="lm_resenas"], [id^="shopify-section-"][id*="lm-resenas"]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reducedMotion(win) ? 'auto' : 'smooth', block: 'start' });
    });

    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
    else start();
  }

  var module_api = {
    version: 3,
    // lógica pura (la usan las pruebas en Node)
    normalize: normalize,
    sortReviews: sortReviews,
    computeSummary: computeSummary,
    publicData: publicData,
    summaryMismatch: summaryMismatch,
    pickFeatured: pickFeatured,
    pickSample: pickSample,
    average10: average10,
    formatTenths: formatTenths,
    formatRating: formatRating,
    formatCount: formatCount,
    starsFillPercent: starsFillPercent,
    nextCount: nextCount,
    pageSequence: pageSequence,
    distribute: distribute,
    initial: initial,
    imageBase: imageBase,
    imageUrl: imageUrl,
    fileName: fileName,
    avisosFrom: avisosFrom,
    renderStars: renderStars,
    renderSummary: renderSummary,
    renderMini: renderMini,
    renderHeader: renderHeader,
    renderCard: renderCard,
    esc: esc,
    safeUrl: safeUrl,
    labels: DEFAULT_LABELS,
    // arranque en el navegador
    boot: boot,
  };
  return module_api;
});
